import React from 'react';
import DataStore from '../flux/stores/DataStore.js';
import Layout from './layout.js';
import {Link} from 'react-router-dom';
import Footer from './footer.js';
import ImageSlider from './image-slider.js';
import MoldLogo from '../../svg/mold-logo.js';
import ProjectGrid from './project-grid.js';
// import {lockScrolling, unlockScrolling} from './helper-lib.js';
import {Helmet} from "react-helmet";

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isMobile: false
    };

    // this.lockScrolling = lockScrolling.bind(this);
    // this.unlockScrolling = unlockScrolling.bind(this);
  }

  componentDidMount() {
    document.body.classList.remove('home-logo-hidden');
    document.body.classList.remove('transparent-header');
    window.addEventListener('resize', this.handleResize);
    window.dispatchEvent(new Event('resize'));

    if(!(this.props.location.hash === '#projects')) {
      // this.lockScrolling();
    } else {
      document.body.classList.add('hide-intro');
      setTimeout(()=>{document.body.classList.add('hide-intro');}, 1000);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    document.body.classList.remove('hide-intro');
    // if(this.scrollLocked === true) {
    //   this.unlockScrolling();
    // }
  }

  handleResize = () => {
    if(window.innerWidth <= 900) {
      this.setState({
        isMobile: true
      });
    } else {
      this.setState({
        isMobile: false
      });
    }
  }

  hideIntro = () => {
    document.body.classList.add('hide-intro');
    // this.unlockScrolling();
  }

  render() {
    const home = DataStore.getPageBySlug('home');
    let hash = this.props.location.hash;

    return (
      <div>
        <Helmet>
          <title>Mold Architects</title>
          <meta name="description" content={home.yoast.metadesc} />
          <meta name="keywords" content={home.yoast.metakeywords} />

          <meta property="og:title" content={home.yoast['opengraph-title'] || 'Mold Architects'} />
          <meta name="og:description" content={home.yoast['opengraph-description'] || home.yoast.metadesc} />
          <meta property="og:image" content={home.yoast['opengraph-image']} />

          <meta name="twitter:title" content={home.yoast['twitter-title'] || 'Mold Architects'} />
          <meta name="twitter:description" content={home.yoast['twitter-description'] || home.yoast.metadesc} />
          <meta name="twitter:image" content={home.yoast['twitter-image'] || home.yoast['opengraph-image']} />
        </Helmet>
        <Layout>
          {hash !== '#projects' ?
          <div>
          <Link to="/" className="home-logo"><MoldLogo /></Link>
          {home.acf.video_mp4.length > 0 ?
          <section id="home-video" className="home-video bg-video-cnt mold-big-logo" onClick={this.hideIntro}>
            <video autoPlay loop muted className="bg-video" poster={home.acf.video_poster}>
              <source src={home.acf.video_mp4} type="video/mp4" />
              {home.acf.video_webm ?
              <source src={home.acf.video_webm} type="video/webm" />:null
              }
              {home.acf.video_ogv ?
              <source src={home.acf.video_ogv} type="video/ogg" />:null
              }
            </video>
          </section>:
          <section id="home-slider" className="home-slider" onClick={this.hideIntro}>
            {!this.state.isMobile ?
              <ImageSlider slides={home.acf.home_slideshow} />:<ImageSlider slides={home.acf.home_slideshow_mobile} />
            }
            <div className="mold-big-logo" />
          </section>
          }
          </div>:null
          }
          <ProjectGrid />
        </Layout>
        <Footer footerClass="home" />
      </div>
      );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/scripts/components/home.js